/**
 * App flavor UI (CORE-8116): the FedEx badge and the "App" filter shared by the Users, Crashes,
 * Diagnostics and User Detail pages.
 *
 * Only FedEx is badged. Locate2u is the default app and every row that predates the tag is
 * Locate2u, so badging it too would put a label on almost every row and make the FedEx ones harder
 * to spot — the point of the badge is to stand out.
 */
import type { AppFlavor } from '../api/client';

/** The filter's value: '' = all apps. */
export type AppFilterValue = '' | AppFlavor;

export function parseAppFilter(value: string | null): AppFilterValue {
  return value === 'fedex' || value === 'locate2u' ? value : '';
}

export function AppBadge({ flavor }: { flavor?: AppFlavor }) {
  if (flavor !== 'fedex') return null;
  return (
    <span className="badge badge-fedex" title="FedEx SameDay app">
      FedEx
    </span>
  );
}

export function AppFilterSelect({
  value,
  onChange,
  className,
}: {
  value: AppFilterValue;
  onChange: (value: AppFilterValue) => void;
  className?: string;
}) {
  return (
    <select
      aria-label="App"
      value={value}
      onChange={(e) => onChange(parseAppFilter(e.target.value))}
      className={
        className ??
        'px-4 py-2 border border-gray-300 rounded-lg bg-white text-gray-900 focus:outline-none focus:ring-2 focus:ring-primary-500'
      }
    >
      <option value="">All Apps</option>
      <option value="locate2u">Locate2u</option>
      <option value="fedex">FedEx</option>
    </select>
  );
}
